// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleContainer_titleContainer__37VQV","text":"TitleContainer_text__E_sWW"};